// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-profiles-explorer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(148, 163, 184, 0.4);
}

.client-profiles-header h3 {
  margin-bottom: 0.5rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 1rem;
}

.client-profiles-header p {
  margin-bottom: 1.25rem;
}

.client-profiles-status {
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(59, 130, 246, 0.08);
  color: #0f172a;
  font-weight: 500;
}

.client-profiles-status.error {
  background: rgba(248, 113, 113, 0.15);
  color: #991b1b;
}

.client-profiles-browser {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.client-profile-tabs {
  margin-top: 1.1rem;
  display: flex;
  gap: 0.75rem;
  overflow-x: auto;
  padding-bottom: 0.35rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.55) transparent;
  position: relative;
  z-index: 10;
}

.client-profile-tabs::-webkit-scrollbar {
  height: 6px;
}

.client-profile-tabs::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 999px;
}

.App.light .client-profile-tabs {
  scrollbar-color: rgba(37, 99, 235, 0.45) transparent;
}

.App.light .client-profile-tabs::-webkit-scrollbar-thumb {
  background: rgba(37, 99, 235, 0.4);
}

.App.dark .client-profile-tabs,
.app-overlay-root.dark .client-profile-tabs {
  scrollbar-color: rgba(148, 163, 184, 0.35) transparent;
}

.App.dark .client-profile-tabs::-webkit-scrollbar-thumb,
.app-overlay-root.dark .client-profile-tabs::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
}

.client-profile-tab {
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  padding: 0.5rem 1rem;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 0 0 auto;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.client-profile-tab:hover {
  border-color: #2563eb;
  color: #1d4ed8;
  background: transparent;
}

.client-profile-tab.active {
  background: #1d4ed8;
  color: #f9fafb;
  border-color: #1d4ed8;
}

.App.light .client-profile-tab {
  background: transparent;
  border-color: #d1d5db;
  color: #1f2937;
  font-weight: 600;
}

.App.light .client-profile-tab:hover {
  border-color: #2563eb;
  color: #1d4ed8;
  background: transparent;
}

.App.light .client-profile-tab.active {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: #f9fafb;
  border-color: #1d4ed8;
}

.client-profile-detail {
  border: 1px solid rgba(148, 163, 184, 0.5);
  border-radius: 16px;
  padding: 1.5rem;
  background: rgba(249, 250, 251, 0.7);
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;
  overflow: hidden;
}

.client-profile-content {
  transition: opacity 0.2s ease;
}

.client-profile-number {
  margin: 0 0 0.25rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.client-profile-meta-note {
  margin: 0 0 0.75rem 0;
  font-size: 0.82rem;
  color: #64748b;
  font-style: italic;
}

.client-profile-detail.obscured .client-profile-content {
  opacity: 0.1;
  pointer-events: none;
}

.client-profile-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 3rem;
  background: rgba(15, 23, 42, 0.55);
  z-index: 5;
}

.client-profile-mask-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  text-align: center;
}

.client-profile-mask-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #f8fafc;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.client-profile-mask-subtitle {
  margin: 0;
  font-size: 0.95rem;
  color: rgba(248, 250, 252, 0.85);
}

.client-profile-reveal-btn {
  padding: 0.85rem 1.75rem;
  border-radius: 999px;
  border: none;
  background: #f8fafc;
  color: #111827;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.client-profile-reveal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.35);
}

.client-profile-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.profile-grid-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.profile-grid-row.full-width {
  grid-template-columns: 1fr;
}

.profile-grid-row.full-width .profile-section {
  width: 100%;
}

.profile-section {
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 14px;
  background: var(--surface-color);
  padding: 1rem 1.25rem;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.06);
}

.profile-section h4 {
  margin: 0 0 0.65rem 0;
  font-size: 0.85rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(15, 23, 42, 0.75);
}

.profile-list {
  list-style: disc;
  padding-left: 1.1rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.95rem;
  color: #0f172a;
}

ol.profile-list,
.profile-list.numbered {
  list-style: decimal;
}

.profile-list.compact {
  gap: 0.3rem;
  font-size: 0.9rem;
}

.profile-flat-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.profile-flat-list.compact {
  gap: 0.35rem;
}

.profile-flat-list.compact .profile-flat-item {
  font-size: 0.9rem;
}

.profile-flat-item {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  font-size: 0.95rem;
  color: #0f172a;
}

.profile-tag {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.15);
  color: #047857;
  flex-shrink: 0;
}

.profile-tag.muted {
  background: rgba(248, 113, 113, 0.18);
  color: #b91c1c;
}

.profile-empty {
  margin: 0;
  font-size: 0.9rem;
  color: rgba(71, 85, 105, 0.8);
}

.client-metadata-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0;
}

.metadata-row dt {
  margin: 0;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(71, 85, 105, 0.85);
}

.metadata-row dd {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}

.client-metadata-list .metadata-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
}

.client-metadata-list .metadata-row dt {
  font-size: 0.75rem;
}

.client-metadata-list .metadata-row dd {
  font-size: 0.9rem;
  text-align: right;
}

.metadata-section,
.transcript-section {
  display: flex;
  flex-direction: column;
}

.section-subtitle {
  margin: 0 0 0.5rem 0;
  font-size: 0.8rem;
  color: rgba(71, 85, 105, 0.85);
}

.transcript-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.transcript-header h4 {
  margin: 0;
}

.transcript-length {
  font-size: 0.7rem;
  font-weight: 500;
  color: rgba(71, 85, 105, 0.85);
  background: rgba(148, 163, 184, 0.15);
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  margin-left: 0.5rem;
}

.persona-meta,
.meta-row {
  transition: background-color 0.15s ease, outline 0.15s ease;
  border-radius: 0.25rem;
  padding: 0.15rem 0.25rem;
  margin: -0.15rem -0.25rem;
  cursor: pointer;
}

.hl {
  outline: 2px solid rgba(0, 0, 0, 0.12);
}

.hl-num_daily { background: #e0f2fe; }
.hl-first_cig { background: #dcfce7; }
.hl-pre_convo_quit_attempt_made { background: #ede9fe; }
.hl-confi_pre { background: #ffedd5; }
.hl-impor_pre { background: #ffe4e6; }
.hl-readi_pre { background: #ccfbf1; }

.client-transcript-scroll {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 0.5rem;
  scrollbar-width: thin;
}

.client-transcript-scroll::-webkit-scrollbar {
  width: 8px;
}

.client-transcript-scroll::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.7);
  border-radius: 10px;
}

.transcript-line {
  padding: 0.65rem 0;
  border-bottom: 1px solid rgba(148, 163, 184, 0.3);
}

.transcript-line:last-child {
  border-bottom: none;
}

.transcript-line .speaker-label {
  display: inline-block;
  font-size: 0.8rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #475569;
  margin-bottom: 0.25rem;
}

.transcript-line p {
  margin: 0;
  font-size: 0.95rem;
}

.transcript-line.transcript-client {
  background: rgba(16, 185, 129, 0.08);
  padding-left: 0.75rem;
  border-radius: 8px;
}

.transcript-line.transcript-counsellor {
  background: rgba(59, 130, 246, 0.08);
  padding-left: 0.75rem;
  border-radius: 8px;
}

.App.dark .client-profiles-status,
.app-overlay-root.dark .client-profiles-status {
  background: rgba(59, 130, 246, 0.15);
  color: #bfdbfe;
}

.App.dark .client-profiles-status.error,
.app-overlay-root.dark .client-profiles-status.error {
  background: rgba(248, 113, 113, 0.25);
  color: #fecaca;
}

.App.dark .client-profile-tab,
.app-overlay-root.dark .client-profile-tab {
  background: rgba(255, 255, 255, 0.05);
  color: #f3f4f6;
  border-color: rgba(148, 163, 184, 0.25);
}

.App.dark .client-profile-tab.active,
.app-overlay-root.dark .client-profile-tab.active {
  background: #2563eb;
  border-color: #2563eb;
}

.App.dark .client-profile-detail,
.app-overlay-root.dark .client-profile-detail {
  background: rgba(17, 24, 39, 0.9);
  border-color: rgba(75, 85, 99, 0.7);
}

.App.dark .client-profile-number,
.app-overlay-root.dark .client-profile-number {
  color: #f1f5f9;
}

.App.dark .client-profile-meta-note,
.app-overlay-root.dark .client-profile-meta-note {
  color: #94a3b8;
}

.App.dark .client-profile-mask,
.app-overlay-root.dark .client-profile-mask {
  background: rgba(15, 23, 42, 0.8);
}

.App.dark .client-profile-reveal-btn,
.app-overlay-root.dark .client-profile-reveal-btn {
  background: #f3f4f6;
  color: #111827;
}

.App.dark .profile-section,
.app-overlay-root.dark .profile-section {
  background: rgba(31, 41, 55, 0.95);
  border-color: rgba(75, 85, 99, 0.6);
  box-shadow: none;
}

.App.dark .profile-section h4,
.app-overlay-root.dark .profile-section h4 {
  color: rgba(226, 232, 240, 0.8);
}

.App.dark .profile-list,
.app-overlay-root.dark .profile-list,
.App.dark .profile-flat-item,
.app-overlay-root.dark .profile-flat-item {
  color: #e5e7eb;
}

.App.dark .profile-empty,
.app-overlay-root.dark .profile-empty {
  color: rgba(226, 232, 240, 0.7);
}

.App.dark .profile-tag,
.app-overlay-root.dark .profile-tag {
  background: rgba(16, 185, 129, 0.25);
  color: #6ee7b7;
}

.App.dark .profile-tag.muted,
.app-overlay-root.dark .profile-tag.muted {
  background: rgba(248, 113, 113, 0.25);
  color: #fecaca;
}

.App.dark .metadata-row dt,
.app-overlay-root.dark .metadata-row dt {
  color: rgba(203, 213, 225, 0.8);
}

.App.dark .metadata-row dd,
.app-overlay-root.dark .metadata-row dd {
  color: #f3f4f6;
}

.App.dark .section-subtitle,
.app-overlay-root.dark .section-subtitle {
  color: rgba(226, 232, 240, 0.75);
}

.App.dark .transcript-length,
.app-overlay-root.dark .transcript-length {
  color: rgba(226, 232, 240, 0.8);
  background: rgba(75, 85, 99, 0.4);
}

.App.dark .hl,
.app-overlay-root.dark .hl {
  outline: 2px solid rgba(255, 255, 255, 0.2);
}

.App.dark .hl-num_daily,
.app-overlay-root.dark .hl-num_daily { background: rgba(14, 165, 233, 0.25); }
.App.dark .hl-first_cig,
.app-overlay-root.dark .hl-first_cig { background: rgba(34, 197, 94, 0.25); }
.App.dark .hl-pre_convo_quit_attempt_made,
.app-overlay-root.dark .hl-pre_convo_quit_attempt_made { background: rgba(139, 92, 246, 0.25); }
.App.dark .hl-confi_pre,
.app-overlay-root.dark .hl-confi_pre { background: rgba(251, 146, 60, 0.25); }
.App.dark .hl-impor_pre,
.app-overlay-root.dark .hl-impor_pre { background: rgba(244, 63, 94, 0.25); }
.App.dark .hl-readi_pre,
.app-overlay-root.dark .hl-readi_pre { background: rgba(20, 184, 166, 0.25); }

.App.dark .transcript-line .speaker-label,
.app-overlay-root.dark .transcript-line .speaker-label {
  color: #cbd5f5;
}

.App.dark .transcript-line.transcript-client,
.app-overlay-root.dark .transcript-line.transcript-client {
  background: rgba(16, 185, 129, 0.12);
}

.App.dark .transcript-line.transcript-counsellor,
.app-overlay-root.dark .transcript-line.transcript-counsellor {
  background: rgba(59, 130, 246, 0.12);
}

@media (max-width: 900px) {
  .profile-grid-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .client-profiles-browser {
    flex-direction: column;
  }

  .client-profile-tabs {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0.5rem;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0.5rem 0;
  }

  .client-profile-tab {
    flex: 0 0 auto;
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }

  .client-profile-detail {
    padding: 1rem;
  }

  .client-profile-grid {
    gap: 1rem;
  }

  .profile-grid-row {
    grid-template-columns: 1fr !important;
    gap: 1rem;
  }

  .profile-section h4 {
    font-size: 0.95rem;
  }

  .profile-list,
  .profile-flat-list {
    font-size: 0.85rem;
  }

  .client-metadata-list {
    font-size: 0.85rem;
  }

  .client-transcript-scroll {
    max-height: 300px;
  }

  .transcript-line p {
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/overlays/ClientProfilesOverlay.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,sDAAsD;EACtD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;EACrC,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,2DAA2D;EAC3D,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,gBAAgB,mBAAmB,EAAE;AACrC,gBAAgB,mBAAmB,EAAE;AACrC,kCAAkC,mBAAmB,EAAE;AACvD,gBAAgB,mBAAmB,EAAE;AACrC,gBAAgB,mBAAmB,EAAE;AACrC,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;uCACuC,oCAAoC,EAAE;AAC7E;uCACuC,mCAAmC,EAAE;AAC5E;yDACyD,oCAAoC,EAAE;AAC/F;uCACuC,oCAAoC,EAAE;AAC7E;uCACuC,mCAAmC,EAAE;AAC5E;uCACuC,oCAAoC,EAAE;;AAE7E;;EAEE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".client-profiles-explorer {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(148, 163, 184, 0.4);\n}\n\n.client-profiles-header h3 {\n  margin-bottom: 0.5rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  font-size: 1rem;\n}\n\n.client-profiles-header p {\n  margin-bottom: 1.25rem;\n}\n\n.client-profiles-status {\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  background: rgba(59, 130, 246, 0.08);\n  color: #0f172a;\n  font-weight: 500;\n}\n\n.client-profiles-status.error {\n  background: rgba(248, 113, 113, 0.15);\n  color: #991b1b;\n}\n\n.client-profiles-browser {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.client-profile-tabs {\n  margin-top: 1.1rem;\n  display: flex;\n  gap: 0.75rem;\n  overflow-x: auto;\n  padding-bottom: 0.35rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.55) transparent;\n  position: relative;\n  z-index: 10;\n}\n\n.client-profile-tabs::-webkit-scrollbar {\n  height: 6px;\n}\n\n.client-profile-tabs::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.6);\n  border-radius: 999px;\n}\n\n.App.light .client-profile-tabs {\n  scrollbar-color: rgba(37, 99, 235, 0.45) transparent;\n}\n\n.App.light .client-profile-tabs::-webkit-scrollbar-thumb {\n  background: rgba(37, 99, 235, 0.4);\n}\n\n.App.dark .client-profile-tabs,\n.app-overlay-root.dark .client-profile-tabs {\n  scrollbar-color: rgba(148, 163, 184, 0.35) transparent;\n}\n\n.App.dark .client-profile-tabs::-webkit-scrollbar-thumb,\n.app-overlay-root.dark .client-profile-tabs::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.45);\n}\n\n.client-profile-tab {\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  padding: 0.5rem 1rem;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 0 0 auto;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n}\n\n.client-profile-tab:hover {\n  border-color: #2563eb;\n  color: #1d4ed8;\n  background: transparent;\n}\n\n.client-profile-tab.active {\n  background: #1d4ed8;\n  color: #f9fafb;\n  border-color: #1d4ed8;\n}\n\n.App.light .client-profile-tab {\n  background: transparent;\n  border-color: #d1d5db;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.App.light .client-profile-tab:hover {\n  border-color: #2563eb;\n  color: #1d4ed8;\n  background: transparent;\n}\n\n.App.light .client-profile-tab.active {\n  background: linear-gradient(135deg, #2563eb, #3b82f6);\n  color: #f9fafb;\n  border-color: #1d4ed8;\n}\n\n.client-profile-detail {\n  border: 1px solid rgba(148, 163, 184, 0.5);\n  border-radius: 16px;\n  padding: 1.5rem;\n  background: rgba(249, 250, 251, 0.7);\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.client-profile-content {\n  transition: opacity 0.2s ease;\n}\n\n.client-profile-number {\n  margin: 0 0 0.25rem 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.client-profile-meta-note {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.82rem;\n  color: #64748b;\n  font-style: italic;\n}\n\n.client-profile-detail.obscured .client-profile-content {\n  opacity: 0.1;\n  pointer-events: none;\n}\n\n.client-profile-mask {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 3rem;\n  background: rgba(15, 23, 42, 0.55);\n  z-index: 5;\n}\n\n.client-profile-mask-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  text-align: center;\n}\n\n.client-profile-mask-title {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #f8fafc;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.client-profile-mask-subtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  color: rgba(248, 250, 252, 0.85);\n}\n\n.client-profile-reveal-btn {\n  padding: 0.85rem 1.75rem;\n  border-radius: 999px;\n  border: none;\n  background: #f8fafc;\n  color: #111827;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.25);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.client-profile-reveal-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.35);\n}\n\n.client-profile-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.profile-grid-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.profile-grid-row.full-width {\n  grid-template-columns: 1fr;\n}\n\n.profile-grid-row.full-width .profile-section {\n  width: 100%;\n}\n\n.profile-section {\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 14px;\n  background: var(--surface-color);\n  padding: 1rem 1.25rem;\n  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.06);\n}\n\n.profile-section h4 {\n  margin: 0 0 0.65rem 0;\n  font-size: 0.85rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(15, 23, 42, 0.75);\n}\n\n.profile-list {\n  list-style: disc;\n  padding-left: 1.1rem;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\nol.profile-list,\n.profile-list.numbered {\n  list-style: decimal;\n}\n\n.profile-list.compact {\n  gap: 0.3rem;\n  font-size: 0.9rem;\n}\n\n.profile-flat-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.profile-flat-list.compact {\n  gap: 0.35rem;\n}\n\n.profile-flat-list.compact .profile-flat-item {\n  font-size: 0.9rem;\n}\n\n.profile-flat-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n\n.profile-tag {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(16, 185, 129, 0.15);\n  color: #047857;\n  flex-shrink: 0;\n}\n\n.profile-tag.muted {\n  background: rgba(248, 113, 113, 0.18);\n  color: #b91c1c;\n}\n\n.profile-empty {\n  margin: 0;\n  font-size: 0.9rem;\n  color: rgba(71, 85, 105, 0.8);\n}\n\n.client-metadata-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.metadata-row dt {\n  margin: 0;\n  font-size: 0.75rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(71, 85, 105, 0.85);\n}\n\n.metadata-row dd {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.client-metadata-list .metadata-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 0.5rem;\n}\n\n.client-metadata-list .metadata-row dt {\n  font-size: 0.75rem;\n}\n\n.client-metadata-list .metadata-row dd {\n  font-size: 0.9rem;\n  text-align: right;\n}\n\n.metadata-section,\n.transcript-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.section-subtitle {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.8rem;\n  color: rgba(71, 85, 105, 0.85);\n}\n\n.transcript-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.transcript-header h4 {\n  margin: 0;\n}\n\n.transcript-length {\n  font-size: 0.7rem;\n  font-weight: 500;\n  color: rgba(71, 85, 105, 0.85);\n  background: rgba(148, 163, 184, 0.15);\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  margin-left: 0.5rem;\n}\n\n.persona-meta,\n.meta-row {\n  transition: background-color 0.15s ease, outline 0.15s ease;\n  border-radius: 0.25rem;\n  padding: 0.15rem 0.25rem;\n  margin: -0.15rem -0.25rem;\n  cursor: pointer;\n}\n\n.hl {\n  outline: 2px solid rgba(0, 0, 0, 0.12);\n}\n\n.hl-num_daily { background: #e0f2fe; }\n.hl-first_cig { background: #dcfce7; }\n.hl-pre_convo_quit_attempt_made { background: #ede9fe; }\n.hl-confi_pre { background: #ffedd5; }\n.hl-impor_pre { background: #ffe4e6; }\n.hl-readi_pre { background: #ccfbf1; }\n\n.client-transcript-scroll {\n  max-height: 420px;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n  scrollbar-width: thin;\n}\n\n.client-transcript-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.client-transcript-scroll::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.7);\n  border-radius: 10px;\n}\n\n.transcript-line {\n  padding: 0.65rem 0;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.3);\n}\n\n.transcript-line:last-child {\n  border-bottom: none;\n}\n\n.transcript-line .speaker-label {\n  display: inline-block;\n  font-size: 0.8rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #475569;\n  margin-bottom: 0.25rem;\n}\n\n.transcript-line p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.transcript-line.transcript-client {\n  background: rgba(16, 185, 129, 0.08);\n  padding-left: 0.75rem;\n  border-radius: 8px;\n}\n\n.transcript-line.transcript-counsellor {\n  background: rgba(59, 130, 246, 0.08);\n  padding-left: 0.75rem;\n  border-radius: 8px;\n}\n\n.App.dark .client-profiles-status,\n.app-overlay-root.dark .client-profiles-status {\n  background: rgba(59, 130, 246, 0.15);\n  color: #bfdbfe;\n}\n\n.App.dark .client-profiles-status.error,\n.app-overlay-root.dark .client-profiles-status.error {\n  background: rgba(248, 113, 113, 0.25);\n  color: #fecaca;\n}\n\n.App.dark .client-profile-tab,\n.app-overlay-root.dark .client-profile-tab {\n  background: rgba(255, 255, 255, 0.05);\n  color: #f3f4f6;\n  border-color: rgba(148, 163, 184, 0.25);\n}\n\n.App.dark .client-profile-tab.active,\n.app-overlay-root.dark .client-profile-tab.active {\n  background: #2563eb;\n  border-color: #2563eb;\n}\n\n.App.dark .client-profile-detail,\n.app-overlay-root.dark .client-profile-detail {\n  background: rgba(17, 24, 39, 0.9);\n  border-color: rgba(75, 85, 99, 0.7);\n}\n\n.App.dark .client-profile-number,\n.app-overlay-root.dark .client-profile-number {\n  color: #f1f5f9;\n}\n\n.App.dark .client-profile-meta-note,\n.app-overlay-root.dark .client-profile-meta-note {\n  color: #94a3b8;\n}\n\n.App.dark .client-profile-mask,\n.app-overlay-root.dark .client-profile-mask {\n  background: rgba(15, 23, 42, 0.8);\n}\n\n.App.dark .client-profile-reveal-btn,\n.app-overlay-root.dark .client-profile-reveal-btn {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.App.dark .profile-section,\n.app-overlay-root.dark .profile-section {\n  background: rgba(31, 41, 55, 0.95);\n  border-color: rgba(75, 85, 99, 0.6);\n  box-shadow: none;\n}\n\n.App.dark .profile-section h4,\n.app-overlay-root.dark .profile-section h4 {\n  color: rgba(226, 232, 240, 0.8);\n}\n\n.App.dark .profile-list,\n.app-overlay-root.dark .profile-list,\n.App.dark .profile-flat-item,\n.app-overlay-root.dark .profile-flat-item {\n  color: #e5e7eb;\n}\n\n.App.dark .profile-empty,\n.app-overlay-root.dark .profile-empty {\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.App.dark .profile-tag,\n.app-overlay-root.dark .profile-tag {\n  background: rgba(16, 185, 129, 0.25);\n  color: #6ee7b7;\n}\n\n.App.dark .profile-tag.muted,\n.app-overlay-root.dark .profile-tag.muted {\n  background: rgba(248, 113, 113, 0.25);\n  color: #fecaca;\n}\n\n.App.dark .metadata-row dt,\n.app-overlay-root.dark .metadata-row dt {\n  color: rgba(203, 213, 225, 0.8);\n}\n\n.App.dark .metadata-row dd,\n.app-overlay-root.dark .metadata-row dd {\n  color: #f3f4f6;\n}\n\n.App.dark .section-subtitle,\n.app-overlay-root.dark .section-subtitle {\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.App.dark .transcript-length,\n.app-overlay-root.dark .transcript-length {\n  color: rgba(226, 232, 240, 0.8);\n  background: rgba(75, 85, 99, 0.4);\n}\n\n.App.dark .hl,\n.app-overlay-root.dark .hl {\n  outline: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.App.dark .hl-num_daily,\n.app-overlay-root.dark .hl-num_daily { background: rgba(14, 165, 233, 0.25); }\n.App.dark .hl-first_cig,\n.app-overlay-root.dark .hl-first_cig { background: rgba(34, 197, 94, 0.25); }\n.App.dark .hl-pre_convo_quit_attempt_made,\n.app-overlay-root.dark .hl-pre_convo_quit_attempt_made { background: rgba(139, 92, 246, 0.25); }\n.App.dark .hl-confi_pre,\n.app-overlay-root.dark .hl-confi_pre { background: rgba(251, 146, 60, 0.25); }\n.App.dark .hl-impor_pre,\n.app-overlay-root.dark .hl-impor_pre { background: rgba(244, 63, 94, 0.25); }\n.App.dark .hl-readi_pre,\n.app-overlay-root.dark .hl-readi_pre { background: rgba(20, 184, 166, 0.25); }\n\n.App.dark .transcript-line .speaker-label,\n.app-overlay-root.dark .transcript-line .speaker-label {\n  color: #cbd5f5;\n}\n\n.App.dark .transcript-line.transcript-client,\n.app-overlay-root.dark .transcript-line.transcript-client {\n  background: rgba(16, 185, 129, 0.12);\n}\n\n.App.dark .transcript-line.transcript-counsellor,\n.app-overlay-root.dark .transcript-line.transcript-counsellor {\n  background: rgba(59, 130, 246, 0.12);\n}\n\n@media (max-width: 900px) {\n  .profile-grid-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .client-profiles-browser {\n    flex-direction: column;\n  }\n\n  .client-profile-tabs {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 0.5rem;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 0.5rem 0;\n  }\n\n  .client-profile-tab {\n    flex: 0 0 auto;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.8rem;\n  }\n\n  .client-profile-detail {\n    padding: 1rem;\n  }\n\n  .client-profile-grid {\n    gap: 1rem;\n  }\n\n  .profile-grid-row {\n    grid-template-columns: 1fr !important;\n    gap: 1rem;\n  }\n\n  .profile-section h4 {\n    font-size: 0.95rem;\n  }\n\n  .profile-list,\n  .profile-flat-list {\n    font-size: 0.85rem;\n  }\n\n  .client-metadata-list {\n    font-size: 0.85rem;\n  }\n\n  .client-transcript-scroll {\n    max-height: 300px;\n  }\n\n  .transcript-line p {\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
